/* eslint-disable max-params */

import getUpdatedAppliedFilters from "./get-updated-applied-filters";
import { DEFAULT_PATHNAME } from "./constants";
import { FILTER_ENTITIES } from "./constants";

// eslint-disable-next-line max-statements, complexity
export const getFilterParamsURL = (customFilter, selectedFilters, spath, filtersInstance, urlOptions, allFilters) => {
    const currentFilter = getUpdatedAppliedFilters(customFilter, selectedFilters);
    const isEqualToInlineSPath = (window.location.pathname).split("?")[0] !== DEFAULT_PATHNAME;
    let inlineFilterPath = DEFAULT_PATHNAME;
    let appliedFilters = [];
    const isRangeFilterApplied = selectedFilters.some((x) => x.isRangeFilter);
    const isModalFilterPresent = selectedFilters.every((x) => x.filterKey === FILTER_ENTITIES.MAKE);
    const isModelPresent = selectedFilters.some((x) => x.subFilterKey === FILTER_ENTITIES.MODEL);
    const updatedSpath = `/${spath.slice(0, spath.length - 1)}`;
    if (customFilter.subFilterKey === "model" && isEqualToInlineSPath && isModalFilterPresent && !isModelPresent) {
        inlineFilterPath = updatedSpath;
    } else if (customFilter.isRangeFilter && selectedFilters.length === 0 && isRangeFilterApplied || (customFilter.isRangeFilter && isRangeFilterApplied && isEqualToInlineSPath)) {
        inlineFilterPath = updatedSpath;
    } else if ((selectedFilters || []).length > 0) {
        inlineFilterPath = DEFAULT_PATHNAME;
        appliedFilters = currentFilter;
    } else {
        inlineFilterPath = updatedSpath;
    }

    const { relativeURL } = filtersInstance.getListingPayload({
        selectedFilters: appliedFilters, filters: allFilters, spath: inlineFilterPath, ...(urlOptions.search && {
            options: {
                search: urlOptions.search
            }
        })
    });

    return {
        relativeURL
    };
};

export const appliedFiltersDataForInlineFilter = (selectedFilters, suggestion, replaceSelectedFilterConnect) => {
    const makeFilterKey = FILTER_ENTITIES.MAKE;
    const { subFilterName, subFilterValue, filterValue } = suggestion;
    const isMakePresent = selectedFilters.some((x) => x.optionKey === suggestion.filterValue);
    const isModelPresent = selectedFilters.some((x) => x.subFilterKey === "model");

    if (isMakePresent && !isModelPresent) {
        replaceSelectedFilterConnect([]);
    }
    const data = {
        displayText: subFilterValue,
        filterKey: makeFilterKey,
        optionKey: filterValue,
        subOptionKey: (subFilterValue || "").charAt(0).toUpperCase() + subFilterValue.slice(1),
        isAllModelVariant: true,
        isSelected: true,
        subFilterKey: subFilterName
    };

    return data;
};
